<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
    </transition>
    <div class="login_footer">
      <el-link href="https://beian.miit.gov.cn/" target="_blank">
        津ICP备2022007839号-7
      </el-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
};
</script>

<style>
.login_footer {
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ddd;
  background: #fff;
  position: fixed;
  bottom: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue